import React, { forwardRef } from "react";

import BillingInfo from "./BillingInfo";

const paymentUI = forwardRef((props, ref) => {
  return (
    <BillingInfo
      // ref={ref}
      // error={props.error}
      // setCardError={props.setCardError}
      // type={props.type}
      ref={ref}
      {...props}
    />
  );
});

export default React.memo(paymentUI);
